
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

const updateNotifyItems = async ({ updates }) => {
  console.log('[UpdateItems] called with updates: ', updates)

  const url = `${baseUrl}/aws/notifications/updateitems`

  try {
    const response = await axios.put(url, { updates })

    if (response.status !== 200) throw new Error('Network response was not ok')

    return response.data
  } catch (error) {
    console.error('Failed to update items:', error)
    throw error
  }
}

export const useUpdateNotifyItems = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: updateNotifyItems,
    onSuccess: (data, variables) => {
      console.log(data, 'variables', variables)
      console.log('[useUpdateItems] Updated items data:', data, 'VARIABLES: ', variables)
      const userPK = variables?.updates?.[0]?.pkValue
      const userId = userPK?.split('USER_')?.[1]
      if (userPK) queryClient.invalidateQueries({ queryKey: ['notifications', 'count', userId] })
      if (userPK) queryClient.invalidateQueries({ queryKey: ['notifications', 'list', userId] })
    },
    onError: error => {
      console.error('[useUpdateItems] Error updating items:', error)
    },
  })

  return mutation
}
